<script setup lang="ts"></script>

<template>
  <section
    class="relative w-full min-h-dvh -mt-[72px] overflow-hidden bg-black"
  >
    <video
      src="/videos/home.mp4"
      class="absolute inset-0 w-full h-full object-cover"
      autoplay
      muted
      loop
      playsinline
      poster="/videos/home.webp"
    ></video>

    <!--    <button-->
    <!--      class="absolute bottom-0 left-1/2 transform -translate-x-1/2 p-6"-->
    <!--      onclick="window.scrollBy({ top: window.innerHeight, behavior: 'smooth' })"-->
    <!--    >-->
    <!--      <UIcon-->
    <!--        class="animate-bounce size-10 text-stone-500"-->
    <!--        name="lucide-chevron-down"-->
    <!--      />-->
    <!--    </button>-->
  </section>
</template>
